import * as types from '../mutation-types'
import subscriptionService from "../../api/subscription-service";
// initial state
const state = []


const actions = {
  getLevels(store) {
    store.commit(types.GET_LEVELS);
    subscriptionService.getLevels(data => {
      store.commit(types.SET_LEVELS, data.levels);
    })
  },
  updateSettings(store, data) {
    subscriptionService.updateLevel({subscription_id: store.getters.getActiveSubscription.id, level_id: data.levelId, onlyWantsLargePieces: data.onlyWantsLargePieces},
        data => {
      store.commit(types.SUCCESS, "Your level is updated");
      router.back();
      let key = Object.keys(data.subscriptions)[0];
      //todo: move to mutation
      store.rootState.subscriptions.subscriptions[key].attributes.levelId = data.subscriptions[key].attributes.levelId;
      store.rootState.subscriptions.subscriptions[key].attributes.onlyWantsLargePieces = data.subscriptions[key].attributes.onlyWantsLargePieces;
    })
  }
}

// mutations
const mutations = {

  [types.SET_LEVELS] (state, levels ) {
    this.state.levels = levels;
  },
  [types.GET_LEVELS] (state, levels ) {
  },

}

export default {
  state,
  actions,
  mutations
}